import { Alert } from "@mui/material";

export default function DetailShell({ children, alerts = [], onDismissAlert }) {
  return (
    <div className="px-0 sm:px-4 sm:py-2 h-[calc(100vh-64px)] supports-[height:100dvh]:h-[calc(100dvh-64px)] sm:h-[calc(100vh-16px)] sm:supports-[height:100dvh]:h-[calc(100dvh-16px)] overflow-hidden">
      {alerts.length > 0 && (
        <div className="fixed top-4 right-4 z-[10100] space-y-2">
          {alerts.map((alert) => (
            <Alert
              key={alert.id}
              severity={alert.severity}
              variant="filled"
              className="min-w-[300px] shadow-lg"
              onClose={() => onDismissAlert?.(alert.id)}
            >
              {typeof alert.message === "string"
                ? alert.message
                : "Bir hata oluştu"}
            </Alert>
          ))}
        </div>
      )}

      <div className="bg-white sm:rounded-2xl sm:shadow-lg sm:border sm:border-gray-200 overflow-hidden flex flex-col h-full">
        {children}
      </div>
    </div>
  );
}
